<script setup lang="ts">
const currentYear = new Date().getFullYear()

const footerColumns = [
  {
    title: 'Company',
    links: [
      { to: '/services', label: 'Services' },
      { to: '/work', label: 'Work' },
      { to: '/inventorai', label: 'Inventorai' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Expertise',
    links: [
      { to: '/cms-migration', label: 'CMS Migration' },
      { to: '/ongoing-support', label: 'Ongoing Support' },
      { to: '/blog', label: 'Blog' },
      { to: '/faq', label: 'FAQ' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy' },
      { to: '/terms', label: 'Terms' },
    ],
  },
]
</script>

<template>
  <footer class="relative overflow-hidden">
    <!-- The dot field the sections stand on, rising from the foot behind the
         wordmark. -->
    <div class="pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_70%_80%_at_50%_100%,#000_25%,transparent)]" aria-hidden="true">
      <div class="cell-dots absolute inset-0"></div>
    </div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-16 md:pt-24 md:pb-20">
      <div class="grid gap-14 lg:grid-cols-12 lg:gap-12">
        <!-- Brand -->
        <div class="lg:col-span-5">
          <NuxtLink to="/" class="inline-block mb-6">
            <span class="text-2xl font-bold tracking-tight text-slate-700 dark:text-white">
              AUGMENT<span class="text-blu-500">BLU</span>
            </span>
          </NuxtLink>
          <p class="leading-relaxed text-slate-700/75 dark:text-white/55">
            Enterprise software development.<br>
            Laravel, Vue.js, Inertia.js and Nuxt specialists.
          </p>
          <div class="mt-8 flex items-center gap-4">
            <a
              href="https://linkedin.com/company/augmentblu/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="AugmentBLU on LinkedIn"
              class="text-slate-700/75 transition-colors hover:text-blu-600 dark:hover:text-blu-400 dark:text-white/50 dark:hover:text-blu-400"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
              </svg>
            </a>
            <p class="text-xs text-slate-700/75 dark:text-white/50">
              &copy; {{ currentYear }} AugmentBLU. Edinburgh, Scotland.
            </p>
          </div>
        </div>

        <!-- Links, grouped -->
        <div class="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7">
          <nav v-for="column in footerColumns" :key="column.title" :aria-label="column.title">
            <p class="mb-5 text-xs font-medium uppercase tracking-[0.25em] text-blu-900 dark:text-blu-400">{{ column.title }}</p>
            <ul class="space-y-3">
              <li v-for="link in column.links" :key="link.to">
                <NuxtLink :to="link.to" class="text-sm text-slate-700/80 transition-colors hover:text-slate-900 dark:text-white/60 dark:hover:text-white">
                  {{ link.label }}
                </NuxtLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>

    <!-- The wordmark, very large and faint, cropped by the page's last edge. -->
    <div class="pointer-events-none relative -mt-6 select-none overflow-hidden" aria-hidden="true">
      <p class="translate-y-[22%] whitespace-nowrap text-center text-[14.5vw] font-bold leading-none tracking-tighter text-slate-900/[0.04] dark:text-white/[0.035]">
        AUGMENT<span class="text-blu-500/[0.12]">BLU</span>
      </p>
    </div>
  </footer>
</template>
